"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBlockPositionEqual = void 0;
/**
 * @includeExample ./src/is-block-position-equal.example.ts
 */
function isBlockPositionEqual(a, b) {
    return a.x === b.x && a.y === b.y;
}
exports.isBlockPositionEqual = isBlockPositionEqual;
